"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePoolContracts = void 0;
var shared_1 = require("../shared");
var _chains_1 = require("../chains");
var useNftSaleContract_1 = require("../contracts/useNftSaleContract");
var useReferralSaleContract_1 = require("../contracts/useReferralSaleContract");
var useSaleContract_1 = require("../contracts/useSaleContract");
var utils_1 = require("../pool/utils");
function usePoolContracts(config, web3) {
    var tokenInstance = _chains_1.idByChain[config.token.chain]
        ? (0, shared_1.useERC20)(config.token.address, web3)
        : undefined;
    var fundTokenInstance = (0, shared_1.useERC20)(config.fundToken.address, web3);
    var saleInstance = (0, utils_1.isNFTPool)(config)
        ? (0, useNftSaleContract_1.useNftSaleContract)(config, web3)
        : config.sale.type === 'referral'
            ? (0, useReferralSaleContract_1.useReferralSaleContract)(config, web3)
            : (0, useSaleContract_1.useSaleContract)(config, web3);
    return { tokenInstance: tokenInstance, saleInstance: saleInstance, fundTokenInstance: fundTokenInstance };
}
exports.usePoolContracts = usePoolContracts;
